import React, { FC } from 'react';
import SearchIcon from '@mui/icons-material/Search';
import { CircularProgress, InputAdornment, TextField, TextFieldProps } from '@mui/material';
import '../../components/social.css';

export declare type SearchUserInput = {
  id: string;
  name: string;
  email: string;
  photoURL: string;
  firebaseUID: string;
  state: 'online' | 'offline' | 'joined' | 'rejoined' | 'left';
};

export interface SearchUserProps {
  textFieldProps?: TextFieldProps;
  isLoading?: boolean;
}

export const SearchUser: FC<SearchUserProps> = ({ textFieldProps, isLoading }) => {
  return (
    <TextField
      variant="outlined"
      placeholder="Search players by name or email"
      type="search"
      className="bh-search"
      inputProps={{ 'aria-label': 'Search players' }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon aria-hidden="true" />
          </InputAdornment>
        ),
        endAdornment: isLoading ? (
          <InputAdornment position="end">
            <CircularProgress
              size={16}
              thickness={5}
              aria-label="Searching"
              sx={{ color: 'var(--bh-accent-text)' }}
            />
          </InputAdornment>
        ) : null,
        style: {
          minHeight: 44,
        },
      }}
      sx={theme => ({
        width: '100%',
        [theme.breakpoints.down('md')]: {
          width: '100%',
        },
      })}
      {...textFieldProps}
    />
  );
};
